let lastSrcs; // 上一次获取到的script地址

const scriptReg = /\<script.*src=["'](?<src>[^"']+)/gm;
const DURATION = 1000 * 10; // 轮询间隔

// 获取最新页面中的script链接
async function extractNewScripts() {
    const html = await fetch("/?timestamp=" + Date.now()).then((res) => res.text());
    scriptReg.lastIndex = 0;
    let result = [];
    let match;
    while ((match = scriptReg.exec(html))) {
        result.push(match.groups.src);
    }
    return result;
}

// 是否有更新
async function needUpdate() {
    const newScripts = await extractNewScripts();
    if (!lastSrcs) {
        lastSrcs = newScripts;
        return false;
    }
    let result = false;
    if (lastSrcs.length !== newScripts.length) {
        result = true;
    }
    for (let i = 0; i < newScripts.length; i++) {
        if (lastSrcs[i] !== newScripts[i]) {
            result = true;
            break;
        }
    }
    lastSrcs = newScripts;
    return result;
}

// 自动更新
function autoRefresh() {
    setTimeout(async () => {
        const willUpdate = await needUpdate();
        if (willUpdate) {
            location.reload();
        }
    }, DURATION);
}

autoRefresh();
